
import React, { useState, useEffect, useCallback } from 'react';
import { OrganizationChart } from 'primereact/organizationchart';

import { getEmployeeList } from '../../EmployeeList/Service/employeeService';
import ComponentLoader from '../../../../Shared/Sidebar/ComponentLoader';

function HrNodeHierarchy() {
    const [employeeList, setEmployeeList] = useState(null);
    const [data, setData] = useState([]);
    const [selection, setSelection] = useState([]);
    let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
    const [Isloading, setIsloading] = useState(false);
    useEffect(() => { getEmployeeIdData(); }, []);
    const [ObservetName, SetObservetName] = useState([])
    const [selection1, setSelection1] = useState([]);

    const getEmployeeIdData = useCallback(async (HierarchyValue) => {
        setIsloading(true);
        var params = {
            OrganisationId: userDetails?.OrgId,
            LoggedInEmployeeId: 0,
            IsDirectReportOrHierarchy: 3,
            SearchText: "",
            FollowersOnly: 0,
            FollowingsOnly: 0,
            IsExEmployeesAlso: 0,
            IsSuggestedOnly: 0,
            pageNumber: 1,
            pageSize: 10000,
            EmployeeId: 101,//userDetails?.EmpId,
             IsSuggestedOnly: 0,
        };
        try {
            let employeesList = await getEmployeeList(params);
            let Obesever101 = employeesList?.Data?.filter((objId) => objId?.OverseerId == 101);
            let ObservetName = Obesever101[0];
            SetObservetName(ObservetName);
            setEmployeeList(employeesList?.Data);
            setIsloading(false);
        } catch (error) {
            setIsloading(false);
            // Handle error
        }
    }, [])

    const data1 = [
        {
            expanded: true,
            type: 'person',
            title: "Arun Mishra",
            data: {
                image: ObservetName.OverseerImage,
                name: ObservetName.OverseerName,
                title: ObservetName.CurrentDesignation,
            },
            children: [
                {
                    expanded: true,
                    type: 'person',
                    name: "Shaw1",
                    data: {
                        image: "https://primefaces.org/cdn/primereact/images/avatar/annafali.png",
                        name: "Anna1",
                        title: "",
                    },
                    children: [
                        {
                            expanded: true,
                            type: 'person',
                            data: {
                                image: "https://primefaces.org/cdn/primereact/images/avatar/annafali.png",
                                name: "Anna Fali",
                                title: "",
                            },
                        },
                        {
                            expanded: true,
                            type: 'person',
                            data: {
                                image: "https://primefaces.org/cdn/primereact/images/avatar/annafali.png",
                                name: "Anna Fali",
                                title: "",
                            },
                        },
                    ],
                },
                {
                    expanded: true,
                    type: 'person',
                    data: {
                        image: "https://primefaces.org/cdn/primereact/images/avatar/stephenshaw.png",
                        name: "Shaw2",
                        title: "",
                    },
                    children: [
                        {
                            expanded: true,
                            type: 'person',
                            data: {
                                image: "https://primefaces.org/cdn/primereact/images/avatar/annafali.png",
                                name: "Anna2",
                                title: "",
                            },
                        },
                    ],
                },
            ],
        },];
       


    const nodeTemplate = (node) => {
        if (node.type === 'person') {
            return (
                <div className="flex flex-column">
                    <div className="flex flex-column align-items-center">
                        <img alt={node.data.name} src={node.data.image} className="mb-3 w-3rem h-3rem" />
                        <span className="font-bold mb-2">{node.data.name}</span>
                        <span>{node.data.title}</span>
                    </div>
                </div>
            );
        }

        return node.label;
    };


    return (
        <div className="card overflow-x-auto">
            <OrganizationChart value={data1} selectionMode="multiple" selection={selection1} onSelectionChange={(e) => setSelection(e.data)} nodeTemplate={nodeTemplate} />
            {Isloading ? <ComponentLoader /> : ""}
        </div>
    )
}






export default HrNodeHierarchy;